export const environment = {
  production: true,
  authServiceUrl: 'https://id.irembohub.com',
  authRealm: 'irembo',
  authClientId: 'officers-portal',
  authSuccessRedirectUrl: 'https://officer.irembo.gov.rw',
  officerRoles: {
    ROLE_OFFICER_ADMIN: 'Officer Admin',
    ROLE_OFFICER_MANAGER: 'Officer Manager',
    ROLE_OFFICER: 'Officer',
  },
  apiGatewayBaseUrl: 'https://officer.api.irembohub.com',
  allowUploadPreviousFiles: false,
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_LOCALE_NAME: 'English',
  translationSourceUrl: 'https://officer.api.irembohub.com',
  officeImportTemplateUrl:
    'https://cdn.api.irembohub.com/cdn/v1/get-link-file/CDNVPK4K',
  customemailValidationRegex:
    /^[^<>()[\]\\,;:%#^\s"$&!@]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
  customphoneValidationRegex: /^07[2-9][0-9]{7}$/,
  AESEncryptionKey: 'encryptionKey',
  isMetabaseDashboardReportsEnabled: false,
  MIXPANEL_TOKEN: 'e60c6096aa29886d825f2bf4701de99f',
  IS_SENDING_ANALYTICS_EVENTS_ACTIVE: true,
  officerFederationEnabled: true,
};
